import type { Testimonial } from '../testimonials'

/**
 * Veysi Küçük's word on the Akkök Holding engagement, under Akkim's mark — he
 * leads Akkim now, and the quote is about the group-wide discipline rather than
 * about Akcoat, whose card carries his earlier words as its General Manager.
 * Both cards are his and they say different things, which is why this is a
 * second entry and not an edit of that one.
 */
export const added: Testimonial = {
  company: 'Akkim',
  logo: { name: 'Akkim', src: '/logo/akkimcard.png' },
  portrait: { src: '/photo/portrait-veysi-kucuk.png', alt: 'Veysi Küçük' },
  quote: [
    'What’s measured gets done. An annual, objective assessment shows where each company '
    + 'stands and makes progress visible. Repeating it across the group helps us turn '
    + 'transformation priorities into commitments we can track.',
  ],
  attribution: 'Veysi Küçük, General Manager, Akkim',
  story: 'akkok-holding',
}
